import { CustomAllocationDTO } from '../DTOs/capital-account/CustomAllocationDTO';

export class CustomAllocation {
  public uuid: string;
  public name: string;
  public orderInTable: number;
  constructor(
    uuid: string,
    name: string,
    orderInTable: number,
  ) {
    this.uuid = uuid;
    this.name = name;
    this.orderInTable = orderInTable;
  }

  static toDTO(entity: CustomAllocation): CustomAllocationDTO {
    return new CustomAllocationDTO(entity.uuid, entity.name, entity.orderInTable);
  }

  static arrayDTOList(entities: CustomAllocation[]): CustomAllocationDTO[] {
    return entities.map((dto) => CustomAllocation.toDTO(dto));
  }
}
